import {Galleria} from 'primereact/galleria';

import styles from './styles.module.css';

const ZGalleria = () => {

  const images = [
    {
      alt: '1',
      src: 'images/pano01_2.jpg',
    },
    {
      alt: '2',
      src: 'images/pano02_2.jpg',
    },
    {
      alt: '3',
      src: 'images/pano03_3.jpg',
    },
    {
      alt: '4',
      src: 'images/pano04_2.jpg',
    },
    // {
    //   alt: '5',
    //   src: 'images/pano05_2.jpg',
    // },
  ];

  const itemTemplate = (item: any) => {
    return (
      <div
        className={styles.imageRoot}
        style={{
          backgroundImage: `url(${item.src})`,
        }}
      />
    );
  };

  return (
    <Galleria
      value={images}
      className={styles.root}
      style={{ height: '100%' }}
      showThumbnails={false}
      showIndicators={false}
      showIndicatorsOnItem={true}
      indicatorsPosition={'bottom'}
      item={itemTemplate}
      autoPlay={true}
      circular={true}
    />
  );
}

export default ZGalleria;